<template>

  <section id="dashboard-ecommerce">
        <Keypress key-event="keyup" @success="key_press" />
    <b-row class="match-height">
      <b-col
        xl="6"
        md="6"
      >
        <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>人員</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0">
        Updated on {{data.datetime}}
      </b-card-text>
    </b-card-header>
    <b-card-body class="">
      <b-row>
        <b-col
          xl="4"
          sm="6"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="LogInIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.in_center}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                宿舍內
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="4"
          sm="6"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-danger"
              >
                <feather-icon
                  size="24"
                  icon="LogOutIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.out_center}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                宿舍外
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="4"
          sm="4"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-warning"
              >
                <feather-icon
                  size="24"
                  icon="TrendingUp"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.total_active_members}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                全部人數
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

    </b-row>
    </b-card-body>
  </b-card>
      </b-col>
      <b-col
        xl="6"
        md="6"
      >
        <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>職員</b-card-title>
      <b-card-text class="font-small-2 mr-25 mb-0">
        Updated on {{data.datetime}}
      </b-card-text>
    </b-card-header>
    <b-card-body class="">
      <b-row>
        <b-col
          xl="4"
          sm="6"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-success"
              >
                <feather-icon
                  size="24"
                  icon="LogInIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.staff_in_center}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                宿舍內
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="4"
          sm="6"
        >
          <b-media no-body>
            <b-media-aside
              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-danger"
              >
                <feather-icon
                  size="24"
                  icon="LogOutIcon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.staff_out_center}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                宿舍外
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

        <b-col
          xl="4"
          sm="4"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                variant="light-warning"
              >
                <feather-icon
                  size="24"
                  icon="TrendingUp"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{data.total_active_staffs}}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                全部職員
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>

    </b-row>
    </b-card-body>
  </b-card>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col lg="5">
        <b-row class="match-height">
          <b-col
            lg="12"
            md="6"
          >
            <!-- <ecommerce-earnings-chart :data="data.earningsChart" /> -->
          </b-col>
         <b-col lg="12">
          <b-card>
            <b-list-group >
    <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="device in devices"
            :key="device.id"
            v-if="device.type == 'DOOR'">
      <span style="font-weight:bold;font-size:1.0rem;">{{ device.name }} <span style="font-size:0.8rem;color:red;">{{ last[device.id] }} </span></span>
      <b-button variant="danger" size="sm" v-if="permission_check(client_module.functions,49)"  @click="open_door(device.id)">OPEN</b-button>
    </b-list-group-item>    
  </b-list-group>
          </b-card>
          <b-card>
            <h5>Users List</h5>
            <b-list-group >
              <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="user in users" :key="user.user_id">
                <span style="font-size:1.0rem;" :class="user.entry_status">{{ user.zh_name }} {{ user.en_name }} </span>
                <b-badge v-if="user.entry_status == 'in_center'">{{ user.in_time }}</b-badge>
                <b-badge v-if="user.entry_status == 'out_center'">{{ user.out_time }}</b-badge>

              </b-list-group-item>    
            </b-list-group>
          </b-card>
         </b-col>
          <b-col
            lg="6"
            md="3"
            cols="6"
          >
          </b-col>

        </b-row>
      </b-col>

      <b-col lg="7">
        <ecommerce-revenue-report :data="data.revenue" />
      </b-col>
    </b-row>

  </section>
</template>

<script>
import { BRow, BCol, BCard, BButton,BListGroup,BBadge,BListGroupItem,

       BCardHeader, BCardTitle, BCardText, BCardBody,  BMedia, BMediaAside, BAvatar, BMediaBody

 } from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
import EcommerceOrderChart from './EcommerceOrderChart.vue'
import EcommerceProfitChart from './EcommerceProfitChart.vue'
import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
import EcommerceMeetup from './EcommerceMeetup.vue'
import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import EcommerceTransactions from './EcommerceTransactions.vue'

export default {
  components: {
    BRow,
    BCol,
    Keypress: () => import('vue-keypress'),
    BButton,
    BBadge,BCardHeader, BCardTitle, BCardText, BCardBody,  BMedia, BMediaAside, BAvatar, BMediaBody,
    BCard,
    EcommerceMedal,
    BListGroup,
    BListGroupItem,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceOrderChart,
    EcommerceProfitChart,
    EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceMeetup,
    EcommerceBrowserStates,
    EcommerceGoalOverview,
    EcommerceTransactions,
  },
  data() {
    return {
      data: {},
      centerId: 0,
      stats: {},
      centerName: '',
      devices: {},
      users: [],
      client_module:JSON.parse(localStorage.getItem('userData')),
      last : {},
      key_press_enabled : true,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  watch: {
    last_person: {
      handler(newValue, oldValue) {
        if (newValue.user_type == 'MEMBER' ) {
          this.last[newValue.device] = newValue.code
        } else {
          this.last[newValue.device] = newValue.name
        }
        this.get_dashboard()
      },
    },
  },
  computed :{
    last_person() {
    //  return this.$store.getters['center/last_person']
    },
  },
  methods: {
    get_dashboard() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/center/`+this.$store.getters['center/currentCenterId']+`/dashboard/`)
        .then(res => {
          this.users = res.data.entry_list
          this.data = res.data.stats
        })
    },
    // get_stats() {
    //   this.$http.get(process.env.VUE_APP_API_BASE+`/center/`+this.$store.getters['center/currentCenterId']+`/dashboard/stats/`)
    //     .then(res => {
    //       this.stats = res.data
    //     })
    // },
    key_press(r) {
        if (this.key_press_enabled === false) {
            return
        }
        if (r.event.keyCode == 123) {
            open_door
        }
    },
    get_device() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/center/${this.centerId}/device/`)
        .then(res => {
          this.devices = res.data
        })
    },
    open_door(sn) {
      this.$http.post(process.env.VUE_APP_AC_API_BASE+`/set_door/`+sn+`/on`)
        .then(res => {

        })
    },
  },
  created() {
    this.$http.defaults.headers.Token = this.userData.token
    this.centerId = this.$store.getters['center/currentCenterId']
    this.centerName = this.$store.getters['center/currentCenterName']
    this.get_device()
    this.get_dashboard()
//    console.log(process.env.VUE_APP_API_BASE)
    // data
    this.$http.get('/ecommerce/data')
      .then(response => {
        this.data = response.data

        // ? Your API will return name of logged in user or you might just directly get name of logged in user
        // ? This is just for demo purpose
        const userData = getUserData()
        this.data.congratulations.name = userData.fullName.split(' ')[0] || userData.username
      })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>

<style>
.out_center {
  color: #eee;
}
.in_center {
  font-weight: bold;
   color: #0a0;
}
</style>